import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  jobOrderLabel: {
    color: theme.palette.grey[600]
  },
  actionButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2)
  }
}));
